import React from "react";
import Navbar from './Navbar.js';
import $ from 'jquery';
import './App.css';

function Map(){

    function showUl(){
        document.getElementById("map1ul").style.display = "inline-block";
    }

    function hideUl(){
        document.getElementById("map1ul").style.display = "none";
    }

    function showUl2(){
        document.getElementById("map2ul").style.display = "inline-block";
    }

    function hideUl2(){
        document.getElementById("map2ul").style.display = "none";
    }

    function showUl3(){
        document.getElementById("map3ul").style.display = "inline-block";
    }

    function hideUl3(){
        document.getElementById("map3ul").style.display = "none";
    }
    return(
        <>
        <Navbar />
        <section id="map">
            <div className="container">
                <h1 className="transmission-h1" data-aos="zoom-in-right">
                            MAP
                        </h1>
                    <div class="row map-row">
                        <div class="col-md-4 col-sm-12 col-lg-4 col-12" onMouseEnter={showUl} onMouseLeave={hideUl} data-aos="zoom-in-right">
                            <h1 className="map-h1" id="map1">
                                Phase 1
                            </h1>
                            <ul className="map-ul" id="map1ul">
                                <li>
                                Genesis collection launch
                                </li>
                                <li>
                                Passive staking
                                </li>
                                <li>
                                $FRAGZ generation
                                </li>
                                <li>
                                5 custom 1/1 FEW NFTs
                                </li>
                                
                            </ul>
                        </div>
                    </div>

                    <div class="row map-row">
                        <div class="col-md-4 col-sm-12 col-lg-4 col-12" onMouseEnter={showUl2} onMouseLeave={hideUl2} >
                            <h1 className="map-h1" id="map2">
                                Phase 2
                            </h1>
                            <ul className="map-ul" id="map2ul">
                                <li>
                                Genesis collection launch
                                </li>
                                <li>
                                Passive staking
                                </li>
                                <li>
                                $FRAGZ generation
                                </li>
                                <li>
                                5 custom 1/1 FEW NFTs
                                </li>
                                
                            </ul>
                        </div>
                    </div>


                    <div class="row map-row">
                        <div class="col-md-4 col-sm-12 col-lg-4 col-12" onMouseEnter={showUl3} onMouseLeave={hideUl3}>
                            <h1 className="map-h1" id="map3">
                                Phase 3
                            </h1>
                            <ul className="map-ul" id="map3ul">
                                <li>
                                Genesis collection launch
                                </li>
                                <li>
                                Passive staking
                                </li>
                                <li>
                                $FRAGZ generation
                                </li>
                                <li>
                                5 custom 1/1 FEW NFTs
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                    </div>
        </section>
        </>
    );
}

export default Map;